import React from 'react'
import type { PaginationInfoProps } from './pagination.types'
import { defaultTranslate } from './pagination.default'

export const PaginationInfo: React.FC<PaginationInfoProps> = ({
  startItem,
  endItem,
  totalRecords,
  t = defaultTranslate,
}) => {
  return (
    <span className="tw-text-sm tw-font-medium tw-text-slate-600"> {/** tw-text-content-base */}
      {t('ui.pagination.showing')}{' '}
      <span className="tw-font-semibold tw-text-focus-100">
        {startItem}-{endItem}
      </span>{' '}
      {t('ui.pagination.of')}{' '}
      <span className="tw-font-semibold tw-text-focus-100">
        {totalRecords}
      </span>
    </span>
  )
}


